// `Symbol.match` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.match
require('../internals/define-well-known-symbol')('match');



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/modules/es.symbol.match.js
// module id = 601
// module chunks = 0